/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterFSmall = createReactComponent("outline", "letter-f-small", "IconLetterFSmall", [["path", { "d": "M10 12h3", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8", "key": "svg-1" }]]);

export { IconLetterFSmall as default };
//# sourceMappingURL=IconLetterFSmall.mjs.map
